

function gtm_adTrackAddToCart (obj) {
//   const eventId = `${getPP105daByCookie()}_${generateUUID()}`
  window.dataLayer && window.dataLayer.push({
    add_to_cart_product: {
      name: obj.product_name,
      id: obj.product_id,
      price: obj.price.toString(),
      category: obj.category_tree,
      quantity: obj.quantity,
      item_ids: [obj.sku_id.toString()],
      sku_id: obj.sku_id,
      brand: 'PatPat',
    //   event_id: eventId,
      sku_image: cdnUrl({ url: obj.sku_image, size: '1300x1300', isSupportWebp: obj.isSupportWebp })
    }
  })
}

function gtm_cartToCheckoutClick () {
  window.dataLayer && window.dataLayer.push({
    event: 'cart_to_checkout_click'
  })
}

function gtm_userRegistered (isLogined, email) {
  if(email) {
    g_setRootDomainCookie('user_email', email, 365)
  }
  window.dataLayer.push({
    registere_status: isLogined ? 'success' : 'failed',
    event: 'user_registered'
  })
}

function gtm_userSubscribe (obj) {
  g_setRootDomainCookie('user_email', obj.subscribe_email, 365)
  window.dataLayer && window.dataLayer.push({
    subscribe_type: obj.subscribe_type,
    subscribe_email: obj.subscribe_email,
    event: 'subscribe'
  })
}

